import { definePlayerFeature } from "../../feature.js";
import { listen } from "@videojs/utils/dom";
import { isMediaSourceCapable } from "@videojs/media";
//#region src/dom/store/features/source.ts
const sourceFeature = definePlayerFeature({
	name: "source",
	state: ({ target, signals }) => ({
		source: null,
		canPlay: false,
		loadSource(src) {
			signals.clear();
			const { media } = target();
			if (!isMediaSourceCapable(media)) return src;
			media.src = src;
			media.load();
			return src;
		}
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaSourceCapable(media)) return;
		const sync = () => set({
			source: media.currentSrc || media.src || null,
			canPlay: media.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA
		});
		sync();
		listen(media, "canplay", sync, { signal });
		listen(media, "canplaythrough", sync, { signal });
		listen(media, "loadstart", sync, { signal });
		listen(media, "emptied", sync, { signal });
	}
});
//#endregion
export { sourceFeature };

//# sourceMappingURL=source.js.map